<script setup lang="ts">
import type { ElementItem } from "@edco/apollo";
import type { BlockElement_rte } from "~/models/generated/BlockElement_rte";

defineProps<{
  content: ElementItem<BlockElement_rte>,
  settings?: ElementItem
}>();
</script>

<template>
  <div class="editor-rte">
    <rich-text :content="content.properties.rte" />
  </div>
</template>

<style scoped lang="scss">
.editor-rte {
  /* stylelint-disable-next-line selector-pseudo-element-no-unknown */
  :deep( img ) {
    max-width: 100% !important;
    object-fit: contain;
  }

  :deep( a ) {
    text-decoration: underline;
  }

  :deep( p ) {
    word-break: break-word;
  }

  :deep( .embeditem ) > iframe {
    max-width: 100%;
  }

  ::v-deep( :first-child ) {
    margin-top: 0;
  }
}
</style>
